import { render } from "./AddressBook.vue?vue&type=template&id=032bde58"
import script from "./AddressBook.vue?vue&type=script&lang=js"
export * from "./AddressBook.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__